import React, { useEffect } from 'react';
import { Link, useParams, useNavigate } from 'react-router-dom';
import { useSite } from '../context/SiteContext';
import { useLang } from '../context/LangContext';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Toaster } from '../components/ui/toaster';
import { ArrowLeft, Loader2 } from 'lucide-react';
import {
  buildLegalNotice,
  buildPrivacyPolicy,
  buildCookiePolicy,
} from '../legal/templates';

const builders = {
  'aviso-legal': buildLegalNotice,
  privacidad: buildPrivacyPolicy,
  cookies: buildCookiePolicy,
};

const LegalPage = () => {
  const { type } = useParams();
  const { content, loading } = useSite();
  const { lang, t } = useLang();
  const navigate = useNavigate();

  useEffect(() => { window.scrollTo(0, 0); }, [type, lang]);

  if (loading || !content) {
    return (
      <div className="min-h-screen bg-[#0d1b2a] flex items-center justify-center">
        <Loader2 className="w-8 h-8 text-[#00e0c7] animate-spin" />
      </div>
    );
  }

  const builder = builders[type];
  if (!builder) {
    navigate('/');
    return null;
  }

  const data = builder(content.legal || {}, lang);

  return (
    <div className="bg-[#0d1b2a] min-h-screen flex flex-col">
      <Header />
      <main className="flex-1 pt-32 pb-24">
        <div className="max-w-3xl mx-auto px-6 lg:px-10">
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-white/50 hover:text-[#00e0c7] text-sm mb-10 transition-colors"
          >
            <ArrowLeft className="w-4 h-4" />
            {t('legal.backToHome')}
          </Link>

          <div className="mb-12">
            <div className="text-[11px] uppercase tracking-[0.3em] text-[#00e0c7] mb-4">
              · Legal
            </div>
            <h1 className="font-display text-white text-4xl lg:text-[56px] font-light tracking-tight leading-[1.05]">
              {data.title}
            </h1>
            {data.lastUpdate && (
              <p className="mt-4 text-white/40 text-sm">
                {t('legal.lastUpdate')}: {data.lastUpdate}
              </p>
            )}
          </div>

          <div className="space-y-12">
            {data.sections.map((s, i) => (
              <section key={i}>
                <h2 className="font-display text-white text-2xl lg:text-3xl font-light mb-5">
                  {s.title}
                </h2>
                <div className="space-y-4">
                  {s.paragraphs.map((p, idx) => (
                    <p key={idx} className="text-white/65 text-[15px] leading-[1.8] whitespace-pre-line">
                      {p}
                    </p>
                  ))}
                </div>
              </section>
            ))}
          </div>
        </div>
      </main>
      <Footer />
      <Toaster />
    </div>
  );
};

export default LegalPage;
